import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-2 -mb-2">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionTag = ({ index, label, testId }) => (
  <Reveal>
    <div className="flex items-center gap-4" data-testid={testId}>
      <span className="font-mono2 text-xs tracking-[0.3em] text-[#2E3192]">{index}</span>
      <span className="h-px w-12 bg-[#6DC8F0]/40" />
      <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">{label}</span>
    </div>
  </Reveal>
);

export const SectionHeading = ({ children, className = "" }) => (
  <Reveal delay={0.08}>
    <h2
      className={`font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight text-slate-900 ${className}`}
    >
      {children}
    </h2>
  </Reveal>
);
